module.exports = __webpack_public_path__ + "img/holovista.cf6c0e60.jpeg";